// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3nkrp","content":"styles_content__3L8Ry","checkbox":"styles_checkbox__2uGV_","checkboxLabel":"styles_checkboxLabel__3jeoR"};